import {Divider, Grid} from '@material-ui/core';
import {SubmitStatusButton} from 'components';
import usePostBin from 'hooks/usePostBin';
import {useContext, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {isObject} from 'utils/objects';
import RightDrawer from './RightDrawer';
import {RightDrawerCodeBox} from './RightDrawer';
import {SocialButton} from './settings/referrals/ReferralWidget';
import {P} from './TypographyShortcuts';
import {H5} from './TypographyShortcuts';
import Copy from 'assets/social/copy.svg';
import {AppCtx} from 'context/AppContext';

const sanitizeData = data => {
    if (isObject(data) && Object.keys(data)?.length) {
        let output = {form_state_json: {}, url: getUrl(data)};
        Object.keys(data.frontend_state).forEach(form => {
            const {user_document_post_response, ...rest} = data.frontend_state[form];
            output.form_state_json[form] = {...rest};
        });
        return output;
    } else {
        return {};
    }
};

const getUrl = data => {
    return data?.frontend_state?._ui_state?.href?.split('.com')?.[1];
};

const FeedbackDetail = ({data, isOpen, toggle, close}) => {
    const postBin = usePostBin();
    const history = useHistory();
    const {setSnackProps, setSnackOpen} = useContext(AppCtx);
    const sanitizedData = sanitizeData(data);

    const handleLoadState = () => {
        postBin.post(sanitizedData);
    };

    useEffect(() => {
        if (postBin?.result) {
            history.push(
                getUrl(data)?.search('forms') !== -1
                    ? `/forms/${getUrl(data).split('/')[3]}/`
                    : getUrl(data) || '/'
            );
        }
        //eslint-disable-next-line
    }, [postBin?.result]);

    return (
        <RightDrawer isOpen={isOpen} toggle={toggle} close={close}>
            <Grid item key='user'>
                <H5>User</H5>
                <P>{data?.user_email}</P>
                <Divider />
            </Grid>
            <Grid item key='date'>
                <H5>Date Submitted</H5>
                <P>{data?.datetime_submitted}</P>
            </Grid>
            <Grid item key='feedback'>
                <H5>Feedback Text</H5>
                <P>{data?.feedback_text}</P>
            </Grid>
            <Grid item key='rating'>
                <H5>User Rating</H5>
                <P>{`${data?.user_rating}`}</P>
            </Grid>
            <Grid item key='follow-up'>
                <H5>Follow Up</H5>
                <P>User requests follow up: {`${data?.user_requests_follow_up}`}</P>
                <P>Follow up method: {`${data?.user_follow_up_method}`}</P>
            </Grid>
            <Grid item key='frontend-state'>
                <H5>Frontend state</H5>
                <Grid container spacing={2}>
                    <Grid item>
                        <SubmitStatusButton
                            variant='contained'
                            inProgress={postBin?.submitting}
                            success={postBin?.result}
                            error={postBin?.error}
                            onClick={handleLoadState}
                        >
                            Load State
                        </SubmitStatusButton>
                    </Grid>
                    <Grid item>
                        <SocialButton
                            small
                            icon={Copy}
                            alt='Copy Frontend State'
                            onClick={e => {
                                navigator.clipboard.writeText(
                                    JSON.stringify(sanitizedData, null, 2)
                                );
                                setSnackProps({
                                    severity: 'success',
                                    message: 'State coppied',
                                });
                                setSnackOpen(true);
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                        >
                            Copy Frontend State
                        </SocialButton>
                    </Grid>
                </Grid>
                <RightDrawerCodeBox>
                    {JSON.stringify(sanitizedData, null, 2)}
                </RightDrawerCodeBox>
            </Grid>
        </RightDrawer>
    );
};

export default FeedbackDetail;
export {getUrl};
